/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Customer_Group_No_MembersInputs */

const vi_customer_group_no_members = /** @type {(inputs: Customer_Group_No_MembersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chưa có khách hàng nào trong nhóm`)
};

/**

* @param {Customer_Group_No_MembersInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const customer_group_no_members = /** @type {((inputs?: Customer_Group_No_MembersInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Customer_Group_No_MembersInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_customer_group_no_members(inputs)
});